import { UNITS } from 'components/common/constants';
import { toProperCase } from 'components/common/toolbox';
import React, { Fragment } from 'react';

export function stock_part_fields() {

	return (
		{
			name: '',
			categoryIds: [],
			partNumber: '',
			manufacturer: '',
			description: '',
			primaryVendor: '',
			secondaryVendor: '',
			price: '',
			unitId: '0',
			estimatedHours: '',
			imageUrl: '',
		}
	);
}
export function stock_part_form_layout(handle, firebase, categories, vendors) {

	const unit_options = Object.values(UNITS)?.map((unit) => <option key={unit.id} value={`${unit.id}`}>{`${unit.name}`}</option>);

	return (
		[{
			column_class: 'col-md-7',
			body: [{
				section:
					<Fragment>
						<h3 className="m-t-none m-b">Stock Part Details</h3>
					</Fragment>,
				layout: [{
					grid: 'col-12',
					label: 'Name',
					field: 'name',
					type: 'text',
					valid: ['required']
				}, {
					grid: 'col-12',
					label: 'Categories',
					field: 'categoryIds',
					type: 'multiselect',
					creatable: true,
					options: categories?.map((category) => ({ value: category.id, label: toProperCase(category.name) }))
				}, {
					grid: 'col-6',
					label: 'Part Number',
					field: 'partNumber',
					type: 'text',
					valid: ['required']
				}, {
					grid: 'col-6',
					label: 'Manufacturer',
					field: 'manufacturer',
					type: 'text',
				}, {
					grid: 'col-12',
					label: 'Description',
					field: 'description',
					type: 'textarea'
				}
				],
			}, {
				section:
					<Fragment>
						<h3 className="m-t-none m-b">Supply</h3>
					</Fragment>,
				layout: [{
					grid: 'col-6',
					label: 'Primary Vendor',
					field: 'primaryVendorId',
					type: 'select',
					options:
						<Fragment>
							<option>Choose ...</option>
							{(vendors?.length < 1) ? null : vendors?.map((vendor) => (<option key={vendor.id} value={`${vendor.id}`}>{`${vendor.displayName}`}</option>))}
						</Fragment>,
				}, {
					grid: 'col-6',
					label: 'Secondary Vendor',
					field: 'secondaryVendorId',
					type: 'select',
					options:
						<Fragment>
							<option>Choose ...</option>
							{(vendors?.length < 1) ? null : vendors?.map((vendor) => (<option key={vendor.id} value={`${vendor.id}`}>{`${vendor.displayName}`}</option>))}
						</Fragment>,
				}, {
					grid: 'col-6',
					label: 'Price',
					field: 'price',
					valid: ['numeric'],
					type: 'number',
				}, {
					grid: 'col-6',
					label: 'Per Unit',
					field: 'unitId',
					type: 'select',
					options:
						<Fragment>
							<option>Choose ...</option>
							{unit_options}
						</Fragment>,
				}, {
					grid: 'col-4',
					label: 'Estimated Hours',
					field: 'estimatedHours',
					valid: ['numeric'],
					type: 'number'
				}, {
					grid: 'col-4',
					label: 'Inventory',
					field: 'inventory',
					valid: ['numeric'],
					type: 'number'
				}, {
					grid: 'col-4',
					label: 'Minimum Inventory',
					field: 'minimumInventory',
					valid: ['numeric'],
					type: 'number'
				}],
			}],
		}, {
			column_class: 'col-md-5',
			body: [{
				section:
					<Fragment>
						<h3 className="m-t-none m-b">Stock Part Image</h3>
					</Fragment>,
				layout: [{
					grid: 'col-12',
					label: 'Stock Part Image',
					field: 'imageUrl',
					type: 'dropzone',
					dropzone: {
						storage: 'firebase',
						storageRef: firebase.storage().ref(),
						bin: handle,
						directory: 'stockParts',
						className: 'mb-3',
						height: "290px",
						multiple: false
					}
				}],
			}],
		}]
	);
}